import { render } from "./connectAppToShortcode.vue?vue&type=template&id=cf45e8d8&scoped=true"
import script from "./connectAppToShortcode.vue?vue&type=script&lang=js"
export * from "./connectAppToShortcode.vue?vue&type=script&lang=js"

import "./connectAppToShortcode.vue?vue&type=style&index=0&id=cf45e8d8&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf45e8d8"]])

export default __exports__